import { Modal, notification } from 'antd';
import Button from '../Button/Button';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import { updateLesson } from '../../services/learnService';

const EditLessonModal = ({
  visible,
  handleCancel,
  saveLesson,
  singleLesson,
  title,
  callback,
  loading = false,
  schoolId,
  courseId,
  lessonId,
  topicId,
}) => {
  const close = () => {
    handleCancel();
    callback();
  };

  const update = async (data) => {
    try {
      await updateLesson(schoolId, courseId, topicId, lessonId, data);
      notification['success']({
        message: 'Lesson updated',
      });
      close();
    } catch (error) {
      notification['error']({
        message: 'An error occcured, try again',
      });
    }
  };

  const initialValues = {
    sn: singleLesson.sn,
    title: singleLesson.title,
  };
  return (
    <Modal
      width={606}
      visible={visible}
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={null}
    >
      <div className='edit-modal'>
        <div className='edit-modal__heading'>
          <p>{title}</p>
        </div>
        <div className='edit-modal__body' style={{ marginBottom: '32px' }}>
          <div className='auth-wrapper__right__form'>
            <Formik
              initialValues={initialValues}
              validationSchema={Yup.object({
                sn: Yup.string().required('Field cannot be empty'),

                title: Yup.string().required('Please enter a title'),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(false);

                const data = {
                  ...values,
                };
                update(data);
              }}
            >
              {({ isSubmitting, isValid }) => (
                <Form>
                  <div className='auth-wrapper__right__form__inputwrapper'>
                    <label htmlFor='email'>Sn</label>

                    <Field type='text' name='sn' id='sn' placeholder='' />
                  </div>

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ marginBottom: '10px' }}
                  >
                    <label htmlFor='password'>Title</label>

                    <Field
                      type={'text'}
                      name='title'
                      id='title'
                      placeholder=''
                    />
                  </div>
                  <div className='edit-modal__bottom'>
                    <p onClick={() => handleCancel()}>Cancel</p>
                    <Button
                      text='Save'
                      className='primary-btn'
                      onClick={saveLesson}
                      disabled={isSubmitting || !isValid}
                      type={'submit'}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditLessonModal;
